<template>
  <v-data-table :headers="headers" :items="desserts">
    <template v-slot:item.authLevel="{ item }">
      {{ item.authLevel == 255 ? "管理員" : "使用者" }}
    </template>

    <template v-slot:item.sn="{ item }">
      {{
        desserts
          .map(function(x) {
            return x.sn;
          })
          .indexOf(item.sn) + 1
      }}
    </template>

    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>使用者列表</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              新增服務成員
            </v-btn>
          </template>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text style="padding-bottom: 0px;">
                <v-col>
                  <v-text-field
                    v-model="editedItem.account"
                    :rules="rules.ruleAccount"
                    hide-details="auto"
                    label="帳號"
                    required
                    placeholder="請輸入使用者帳號"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedItem.password"
                    label="密碼"
                    :rules="rules.rulePassword"
                    required
                    placeholder="請輸入密碼，最少4個字元"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedItem.confirmPassword"
                    label="確認密碼"
                    :rules="
                      rules.ruleconfirmPassword.concat(passwordConfirmationRule)
                    "
                    required
                    placeholder="請再次輸入密碼"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedItem.name"
                    label="使用者名稱"
                    placeholder="請輸入使用者名稱"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedItem.email"
                    label="郵件地址"
                    placeholder="請輸入郵件地址"
                    :rules="rules.email"
                  >
                  </v-text-field>
                </v-col>
                <v-col style="padding-bottom:0">
                  <v-h2>角色:</v-h2>
                  <!-- <div>
                     <input type="radio">
                     <span>使用者</span>
                     <input type="radio">
                     <span>管理員</span></div> -->
                  <v-radio-group
                    v-model="editedItem.authLevel"
                    mandatory
                    row
                    style="margin:0"
                  >
                    <v-radio label="使用者" :value="10"></v-radio>
                    <v-radio label="管理員" :value="255"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  :disabled="!valid"
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon
        v-if="
          item.account !== 'admin' &&
            (item.authLevel != '255' || getUser.account == 'admin')
        "
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        v-if="
          item.account !== 'admin' &&
            (item.authLevel != '255' || getUser.account == 'admin')
        "
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";

export default {
  data: () => ({
    rules: {
      ruleAccount: [
        (value) => !!value || "Required",
        (value) => (value && value.length >= 4) || "Min 4 characters",
      ],
      rulePassword: [
        (value) => !!value || "Required",
        (value) => (value && value.length >= 4) || "Min 4 characters",
      ],

      ruleconfirmPassword: [
        (value) => !!value || "Required",
        (value) => (value && value.length >= 4) || "Min 4 characters",
      ],
      email: [
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      ],
    },

    valid: true,
    role: ["使用者", "管理員"],
    dialog: false,
    headers: [
      { text: "序號", value: "sn", class: "blue lighten-3 black--text" },
      { text: "帳號", value: "account", class: "blue lighten-3 black--text" },
      { text: "名稱", value: "name", class: "blue lighten-3 black--text" },
      {
        text: "角色",
        value: "authLevel",
        class: "blue lighten-3 black--text",
      },
      {
        text: "郵件地址",
        value: "email",
        class: "blue lighten-3 black--text",
      },
      {
        text: "動作",
        value: "actions",
        sortable: false,
        class: "blue lighten-3 black--text",
      },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      account: "",
      password: "",
      confirmPassword: "",
      name: "",
      authLevel: "",
      email: "",
      action: "",
      isIgnoreEdit: false,
    },
    defaultItem: {
      id: 0,
      account: "",
      password: "",
      confirmPassword: "",
      name: "",
      authLevel: "",
      email: "",
      action: "",
    },
    log: "",
  }),

  computed: {
    passwordConfirmationRule() {
      return () =>
        this.editedItem.password === this.editedItem.confirmPassword ||
        "Password must match";
    },
    formTitle() {
      return this.editedIndex === -1 ? "新增服務成員" : "編輯服務帳號";
    },
    ...mapGetters(["getMembers", "getUser", "getAccountFlag"]),
  },
  created() {
    this.initialize();
  },

  watch: {
    getMembers(newCount) {
      this.desserts = JSON.parse(JSON.stringify(newCount));
    },
  },
  methods: {
    initialize() {
      this.$store.dispatch("getUserList", {
        token: this.$cookies.get("token"),
      });
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },
    deleteItem(item) {
      swal
        .fire({
          title: `是否要刪除帳號[${item.account}]`,
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ok",
          cancelButtonText: "cancel",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swal.fire("Deleted!", "Your file has been deleted.", "success");
            this.editedIndex = this.desserts.indexOf(item);
            this.editedItem = Object.assign({}, item);

            this.desserts.splice(this.editedIndex, 1);
            this.deleteUser({
              token: this.$cookies.get("token"),
              sn: this.editedItem.sn,
            });
            this.closeDelete();
          }
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate() == true) {
        this.editedItem["token"] = this.$cookies.get("token");

        this.editedItem["roleSn"] = this.desserts[0].roleSn;
        console.log(this.editedItem);
        this.$store.dispatch("checkAccount", this.editedItem).then(() => {
          if (this.getAccountFlag) {
            console.log(this.editedIndex);
            if (this.editedIndex > -1) {
              this.editedItem["token"] = this.$cookies.get("token");
              this.editedItem["index"] = this.editedIndex;
              this.$store.dispatch("editUser", this.editedItem).then(() => {
                this.initialize();
              });
            } else {
              this.$store.dispatch("createUser", {
                token: this.$cookies.get("token"),
                account: this.editedItem.account,
                password: this.editedItem.password,
                name: this.editedItem.name,
                email: this.editedItem.email,
                authLevel: this.editedItem.authLevel,
                roleSn: this.desserts[0].roleSn,
              });
            }
            this.close();
          } else {
            swal.fire({
              icon: "warning",
              title: "帳號重複請重新更改",
            });
          }
        });
      } else {
        swal.fire({
          icon: "warning",
          title: "請確認密碼或格式是否相符",
        });
      }
    },
    ...mapActions([
      "editUser",
      "getUserList",
      "getUserByID",
      "createUser",
      "deleteUser",
      "checkAccount",
    ]),
  },
};
</script>

<style></style>
